import Enum from "@/util/enum";
import EnumValue from ".";

export default class ActiveTypingReq extends Enum {
  static SEND_REQUEST: EnumValue = { name: "Send Request", code: 0 };
  static PENDING: EnumValue = { name: "Pending", code: 1 };
  static SENT: EnumValue = { name: "Sent", code: 2 };
}
